// Libs
import React from 'react';
import { CardActionArea, CardMedia } from '@mui/material';

// Components
import NewLabel from '../../../../Products/Card/NewLabel';
import Image from '../../../../Image';

const IMAGE_DESKTOP_WIDTH_PLACED = 230;
const IMAGE_DESKTOP_WIDTH_DEFAULT = 275;
const IMAGE_TABLET_WIDTH = 298;
const IMAGE_MOBILE_WIDTH = 113;

const CartCardMedia = ({
  product,
  placedOrder,
  unavailableWatermark,
  onOpenModal,
  classes,
}) => {
  const { image_link: image, is_new: isNew } = product || {};

  return (
    <>
      <div onClick={(e) => e.stopPropagation()} className={classes.labels}>
        {isNew && <NewLabel positionStatic />}
      </div>
      <CardActionArea
        data-testid="card-action-area"
        className={classes.actionArea}
        onClick={onOpenModal}>
        {unavailableWatermark}
        <Image
          alt="productImage"
          imageContainer={{
            desktop: placedOrder?.id
              ? [IMAGE_DESKTOP_WIDTH_PLACED]
              : [IMAGE_DESKTOP_WIDTH_DEFAULT],
            tablet: [IMAGE_TABLET_WIDTH],
            mobile: [IMAGE_MOBILE_WIDTH],
          }}
          src={image}>
          <CardMedia
            id="image-button"
            className={classes.img}
            component="img"
            image={image}
            alt="productImage"
          />
        </Image>
      </CardActionArea>
    </>
  );
};

export default CartCardMedia;
